import React, { FC, useEffect } from 'react';

import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';
import { useDispatch, useSelector } from 'react-redux';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';
import { UploadField } from 'view/component/Upload/Upload';
import { ListaAnexosSolicitacao } from 'view/section/Anexos/components/ListaAnexosSolicitacao';
import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { EstadoRequisicao } from 'store/types';
import { P } from 'view/component/Tipografia/Texto';
import { AlertaInline } from 'view/component/AlertaInline/AlertaInline';
import { ApiAnexoSolicitacao } from 'service/api/solicitacao/ApiAnexoSolicitacao';
import { MensagemErro } from 'view/component/Formulario/MensagemErro/MensagemErro';

interface AnexosSolicitacaoSectionProps {
  solicitacao: SolicitacaoResumida
  name: string
}

export const AnexosSolicitacaoSection: FC<AnexosSolicitacaoSectionProps> = ({solicitacao, name}) => {
  const novaSolicitacao = solicitacao.id === 0;

  if (novaSolicitacao) {
    return <AnexosSolicitacaoSectionCadastro name={name} />

  } else {
    return <AnexosSolicitacaoSectionLista solicitacao={solicitacao} />
  }
}


interface AnexosSolicitacaoSectionCadastroProps {
  name: string;
}

const AnexosSolicitacaoSectionCadastro: FC<AnexosSolicitacaoSectionCadastroProps> = ({name}) => {
  return <>
    <legend className="h3">Anexos</legend>
    <UploadField name={`${name}.anexos`} gerarEnderecoEnvio={ApiAnexoSolicitacao.enviarAnexo().gerarEnderecoEnvio} />
    <MensagemErro name={`${name}.anexos`} />
  </>
}

interface AnexosSolicitacaoSectionListaProps {
  solicitacao: SolicitacaoResumida
}

const AnexosSolicitacaoSectionLista: FC<AnexosSolicitacaoSectionListaProps> = ({solicitacao}) => {
  const anexos = useSelector(SolicitacaoCorrenteSelector.anexos.all);
  const estado = useSelector(SolicitacaoCorrenteSelector.anexos.estado);
  const dispatch = useDispatch();
  
  const id = solicitacao.id;

  useEffect(() => {
    if (estado === EstadoRequisicao.OCIOSO) {
      dispatch(SolicitacaoCorrenteAction.anexos.carregar(id))
    }
  }, [id, estado, dispatch]);

  const hasAnexos = estado === EstadoRequisicao.BEM_SUCEDIDO && anexos.length === 0;
  const exibirCarregando = estado !== EstadoRequisicao.BEM_SUCEDIDO;


  return <>
    <legend className="h3">
      Anexos
      { estado === EstadoRequisicao.FALHOU 
        && <AlertaInline mensagem="Não foi possível obter a lista de anexos, tente novamente mais tarde." />
      }
    </legend>

    { hasAnexos && <P>Sem anexos</P>}

    <ListaAnexosSolicitacao
      anexos={anexos}
      isLoading={exibirCarregando}
      />
  </>
}
